var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media-item-container"},[_c('v-icon',[_vm._t("icon")],2),_c('div',{staticClass:"video-details"},[_c('div',{staticClass:"video-name"},[_vm._t("name")],2)]),_c('v-icon',{staticClass:"clock"},[_vm._t("clock")],2),_c('div',{staticClass:"video-details"},[_c('div',{staticClass:"video-duration"},[_vm._t("duration")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }